// extracted by mini-css-extract-plugin
export var chevron = "_ml-1";
export var clickable = "_ml-0";
export var ruleRow = "_ml-2";